import RectangleImage from "./RectangleImage";
import RoundImage from "./RoundImage";

const Image = {
  Rectangle: RectangleImage,
  Round: RoundImage,
};

export default Image;
